<template>
  <div class="uploader-progress" :class="progress >= 100 && isFileAdded ? '--done' : ''">
    <div class="uploader-progress__number">
      <template v-if="progress < 100">
        <span>{{ Math.round(progress) }}%</span>
      </template>
      <transition name="page" mode="out-in">
        <template v-if="progress >= 100 && !isFileAdded">
        </template>
      </transition>
      <transition name="page" mode="out-in">
        <template v-if="progress >= 100 && isFileAdded">
          <span class="text-green-light">
            {{ $t("uploader.status.complete") }}
          </span>
        </template>
      </transition>
    </div>
    <transition name="page" mode="out-in">
      <svg v-if="!isFileAdded" style="transform: rotate(-90deg)" viewBox="0 0 120 120">
        <circle cx="40" cy="40" :r="radius" fill="none" stroke-width="8" style="stroke: #fff" />
        <circle cx="60" cy="60" :r="radius" fill="none" stroke-width="8" :stroke-dasharray="dash"
          :stroke-dashoffset="offset" :style="{ stroke: strokeColor }" />
      </svg>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      radius: 54,
      isFileAdded: false,
    };
  },

  computed: {
    dash() {
      return 2 * Math.PI * this.radius;
    },

    offset() {
      const circ = this.dash;
      const progress = this.progress / 100;

      return circ * (1 - progress);
    },

    strokeColor() {
      return this.progress === 100 ? '#ec268f' : '#ec268f';
    },
  },

  watch: {
    progress(progress) {
      if (progress === 100) {
        setTimeout(() => {
          this.isFileAdded = true;
        }, 100);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.uploader-progress {
  @apply relative ml-4;
  height: 3.5rem;
  width: 3.5rem;

  &.--done {
    display: none;
  }

  &__number {
    @apply absolute flex items-center justify-center;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    span {
      font-size: 0.875rem;
      line-height: 1.25;
    }
  }
}
</style>
